import s from './Point.module.scss';

type PointProps = {
  number: number;
  description: string;
};

function Point({ number, description }: PointProps) {
  return (
    <div className={s.row}>
      <div className={s.point}>{number}</div>
      <div className={s.decsription}>{description}</div>
    </div>
  );
}

export default Point;
